import { ButtonIndexProperty } from 'components/atoms/Button-index-property/Button-index-property';
import { Button } from 'components/atoms/Button/Button';
import { CustomPropertyColorSelect } from 'components/atoms/CustomPropertyColorSelect/CustomPropertyColorSelect';
import { CustomPropertyDate } from 'components/atoms/CustomPropertyDate/CustomPropertyDate';
import { CustomPropertyLabel } from 'components/atoms/CustomPropertyLabel/CustomPropertyLabel';
import { CustomPropertySelect } from 'components/atoms/CustomPropertySelect/CustomPropertySelect';
import { Input, TypeInput } from 'components/atoms/Input/Input';
import { ItemAddProperty } from 'components/atoms/Item-add-property/Item-add-property';
import { IOptionSelect, Select } from 'components/atoms/Select/Select';
import { PopupExistProcess } from 'components/molecules/Popup-exist-porcess/Popup-exist-porcess';
import { PopUpInformative } from 'components/molecules/Popup-informative/Popup-informative';
import { HeaderWithSteps } from 'components/organisms/Header-with-steps/Header-with-steps';
import { AddPropertySkeleton } from 'components/skeleton/organisms/Add-property-skeleton/Add-property-skeleton';
import { typeProperty as appConstants } from 'constants/app.constants';
import { useFormik } from 'formik';
import { TypeProperty } from 'models/app.interface';
import { IDetailStep } from 'models/info.steps.interface';
import { IAppReducer } from 'models/reducer.interface';
import {
  IAddPropertiy,
  IAtribute,
} from 'pages/Create-account/pages/Create-properties/models/Create-properties.interface';
// import {
//   IUserSubscription,
//   IUserSubscriptionProductsData,
// } from 'pages/Edit-Property/models/Edit-Property.interface';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getVehicleFieldSortKey } from 'shared/constants/vehicle-form-order.constants';
import { getYear } from 'shared/constants/year.constants';
// import { getUserPlans } from 'shared/services/plans';
import { createProductProperties } from 'shared/services/products';
import { getUserProperties } from 'shared/services/properties.service';
import { useDateValidation } from 'hooks/useDateValidation';
import { useVehiclesColors } from 'hooks/useVehiclesColors';
import {
  getPropertyInfo,
  getVehicleDataKey,
  isVehicleType,
} from 'utils/properties.utils';
import {
  isValidVin,
  sanitizeVinInput,
  VIN_ERROR_MESSAGE,
} from 'utils/vin.utils';
import { getDataByKey } from 'shared/services/user-add-subscription';
import type { VehicleData } from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import { ContactCard } from '../../components/molecules/Contact-card/Contact-card';
import './Add-property.scss';
import {
  CustomizedStateAddProperty,
  IAttributesPropertyData,
  ITypeProperty,
  ITypePropertyResponse,
} from './models/Add-property.inteface';

export const AddProperty = () => {
  const location = useLocation();
  const steps: IDetailStep[] = [
    {
      description: '',
      state: 'active',
      link: '',
      permissionToNavigate: false,
    },
  ];
  const [step, setStep] = useState<IDetailStep[]>(steps);

  const { typeProperty } = (location.state as CustomizedStateAddProperty) || 1;
  const navigate = useNavigate();
  const {
    authReducer: user,
    branchReducer: { branch },
  } = useSelector((state: IAppReducer) => state);
  const userImpersonationId = user?.agentAuthData?.userId ?? null;
  const year = getYear(branch);

  // Hook para validación de fechas dinámicas
  const { minDate, maxDate } = useDateValidation();

  const [popUp, setPopUp] = useState<{
    type: string;
    showModal: boolean;
    title: string;
    message: string;
    labelButton: string;
    labelButtonCancel: string;
    planId: string | number | undefined;
  }>({
    type: '',
    showModal: false,
    title: '',
    message: '',
    labelButton: '',
    labelButtonCancel: '',
    planId: undefined,
  });
  const [maximumNumberPropertiesAdd, setMaximumNumberPropertiesAdd] =
    useState(10);
  const [count, setCount] = useState<undefined | number>(undefined);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [stepProperties, setStepProperties] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [planesOptions, setPlanesOptions] = useState<IOptionSelect[]>([
    { value: '', description: '', info: '' },
  ]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [atributes, setAtributes] = useState<ITypeProperty | null>(null);
  const [vehicleData, setVehicleData] = useState<VehicleData>({
    autos: {},
    motos: {},
  });
  const [selectedBrands, setSelectedBrands] = useState<Record<number, string>>(
    {}
  );
  const { colors: vehiclesColors } = useVehiclesColors();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formAddPropertyInitialValues: any = {
    userProduct: undefined,
  };

  useEffect(() => {
    (async () => {
      const planOptions = (await getPlans(typeProperty || 1)) as any;
      const defaultOptions = planOptions.find((p: any) => {
        return !p.isDisabled && +(p.info as string).split(' ')[0] > 0;
      });
      handleSelectOption(
        defaultOptions ? (defaultOptions.value as number) : 0,
        planOptions
      );

      await getProperties(typeProperty || 1);
      setIsLoading(false);
    })();
  }, [setPlanesOptions]);

  const getPlans = async (idTypeProperty: number) => {
    try {
      // const response: IUserSubscription[] = await getUserPlans(user.uid);
      const options: IOptionSelect[] = [];
      // response.forEach((item: IUserSubscription) => {
      //   const userProducts =
      //     item.attributes.plan_id.data.attributes.user_products || [];
      //   userProducts.forEach((userProduct) => {
      //     if (
      //       userProduct.product_id &&
      //       userProduct.product_id.product_type_id &&
      //       userProduct.product_id.product_type_id.id === idTypeProperty
      //     ) {
      //       const userProductQuantity = userProduct.quantity || 0;
      //       const propertiesUser =
      //         item.attributes.plan_id.data.attributes.plan_properties?.length ||
      //         0;
      //       const calculateAvailableProperties = Math.abs(
      //         userProductQuantity - propertiesUser
      //       );
      //       options.push({
      //         value: userProduct.id,
      //         description: `${item.attributes.plan_id.data.attributes.alias_title} | ${item.attributes.plan_id.data.attributes.alias_product_type} | Producto #${userProduct.id}`,
      //         info: `${userProductQuantity} propiedades disponibles`,
      //         readonly: calculateAvailableProperties <= 0,
      //         isDisabled: validateTypeProduct(
      //           idTypeProperty,
      //           item.attributes.plan_id.data.attributes.productos.data
      //         ),
      //         id: item.id,
      //       });
      //     }
      //   });
      // });
      options.push({
        value: 0,
        description: 'Sin Cobertura',
        info: '',
        isDisabled: false,
        readonly: false,
        id: 0,
      });
      setStep([
        {
          description: getPropertyInfo(typeProperty).title,
          state: 'active',
          link: '',
          permissionToNavigate: false,
        },
      ]);
      setPlanesOptions(options);
      return options;
    } catch (error) {
      console.log('error', error);
    }
  };

  const getProperties = async (id: number) => {
    try {
      const response: ITypePropertyResponse = await getUserProperties(id);
      setAtributes({ ...response, itemActive: 1 });
      if (isVehicleType(id)) {
        const data = await getDataByKey('brand_and_models');
        setVehicleData(data);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  // const validateTypeProduct = (
  //   idTypeProperty: number,
  //   array: IUserSubscriptionProductsData[]
  // ) => {
  //   let isDisabled = false;
  //   array.forEach((item) => {
  //     if (item.attributes.product_type_id.data.id !== idTypeProperty) {
  //       isDisabled = true;
  //     }
  //   });
  //   return isDisabled;
  // };

  const handlePopUp = (
    type: 'exitsProcess' | 'selectPlan' | undefined,
    id?: string | number
  ) => {
    const infoSetPopUp = {
      showModal: true,
      title: '',
      message: '',
      labelButton: '',
      labelButtonCancel: '',
      type: '',
      planId: id,
    };
    if (type === 'exitsProcess') {
      infoSetPopUp.type = 'exitsProcess';
      infoSetPopUp.title = '¿Deseas salir? ';
      infoSetPopUp.message =
        'Esta por salir del proceso de agregar una nueva propiedad, tenga en cuenta que al dejarlo incompleto deberá iniciar nuevamente. ';
      infoSetPopUp.labelButton = 'Continuar';
      infoSetPopUp.labelButtonCancel = 'Salir';
    } else if (type === 'selectPlan') {
      infoSetPopUp.type = 'selectPlan';
      infoSetPopUp.title = 'Acción requerida';
      infoSetPopUp.message =
        'El plan seleccionado no tiene propiedades disponibles, puede remover un auto del plan o comprar un plan nuevo para poder cubrir más autos.';
      infoSetPopUp.labelButton = 'Comprar plan';
      infoSetPopUp.labelButtonCancel = 'Editar plan';
    } else {
      infoSetPopUp.showModal = false;
    }
    setPopUp({ ...infoSetPopUp });
  };
  const handleStepProperties = (item: number) => {
    if (item > stepProperties.length) {
      stepProperties.push({
        item,
        active: stepProperties.length > 0 ? false : true,
      });
    } else {
      stepProperties.splice(item);
      if (item < (atributes as ITypeProperty).itemActive && item > 0) {
        handleItemActive(item);
      }
      if (item === 0 && atributes) {
        atributes.itemActive = 1;
        setAtributes({ ...atributes });
      }
    }
    setStepProperties([...stepProperties]);
    handleFormControls(
      atributes?.propiedades.data as IAttributesPropertyData[],
      item
    );
  };
  const handleItemActive = (item: number) => {
    stepProperties.map((step) => {
      step.active = false;
    });
    stepProperties[item - 1].active = true;
    setStepProperties([...stepProperties]);
    if (atributes) {
      atributes.itemActive = item;
      setAtributes({ ...atributes });
    }
  };
  const backIndex = () => {
    formAddProperty.setErrors({});
    const itemActive = atributes?.itemActive as number;
    handleItemActive(itemActive - 1);
  };
  const handleFormControls = (
    data: IAttributesPropertyData[],
    item: number
  ) => {
    data.forEach((element) => {
      if (item > stepProperties.length) {
        delete formAddProperty.values[
          `${atributes?.name}__${element.attributes.name}__${element.id}__${
            item + 1
          }`
        ];
      } else {
        formAddProperty.values[
          `${atributes?.name}__${element.attributes.name}__${element.id}__${
            item + 1
          }`
        ] = '';
      }
    });
  };
  const handleClosePopUp = () => {
    handlePopUp(undefined);
    if (popUp.type === 'selectPlan') {
      navigate(`/edit-plan/${popUp.planId}`);
    } else {
      navigate('/settings/properties');
    }
  };

  /** Requeridos para vehículos: Placa, Año, Marca, Modelo. Resto opcionales (Color, VIN, Fecha marbete). */
  const isRequiredVehicleField = (
    name: string | undefined,
    nameIntl: string | undefined
  ) => {
    const n = (name ?? '').toLowerCase();
    const ni = (nameIntl ?? '').toLowerCase();
    return (
      n === 'placa' ||
      ni === 'placa' ||
      n === 'año' ||
      ni === 'año' ||
      n === 'marca' ||
      ni === 'marca' ||
      n === 'modelo' ||
      ni === 'modelo'
    );
  };

  /** Valor vacío o placeholder de select (Marca/Modelo) no cuenta como selección válida. */
  const isRequiredValueEmpty = (
    value: unknown,
    fieldName: string | undefined
  ) => {
    if (value === undefined || value === null) return true;
    if (typeof value !== 'string') return !value;
    const trimmed = value.trim();
    if (trimmed === '') return true;
    const name = (fieldName ?? '').toLowerCase();
    if (name === 'marca' && trimmed.toLowerCase() === 'seleccionar marca')
      return true;
    if (name === 'modelo' && trimmed.toLowerCase() === 'seleccionar modelo')
      return true;
    return false;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formAddPropertyValidate = (values: any) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errors: any = {};
    if (!values.userProduct && typeof values.userProduct !== 'number') {
      errors.userProduct = 'Seleccione un plan';
    }
    atributes?.propiedades.data.forEach((atribute) => {
      const fieldKey = `${atributes.name}__${atribute.attributes.name}__${atribute.id}__${atributes.itemActive}`;
      const value = values[fieldKey];
      const required = isRequiredVehicleField(
        atribute.attributes.name,
        atribute.attributes.name_intl_eng
      );
      if (required && isRequiredValueEmpty(value, atribute.attributes.name)) {
        errors[fieldKey] = 'Campo requerido';
      } else if (
        value !== undefined &&
        value !== '' &&
        String(value).trim() !== ''
      ) {
        if (fieldKey.includes('Año') && Number(value) < year) {
          errors[fieldKey] = `El año debe ser mayor a ${year}`;
        }
        const isVin =
          atribute.attributes.name?.toLowerCase() === 'vin' ||
          atribute.attributes.name_intl_eng?.toLowerCase() === 'vin';
        if (isVin && typeof value === 'string' && !isValidVin(value)) {
          errors[fieldKey] = VIN_ERROR_MESSAGE;
        }
      }
    });
    return errors;
  };
  const formAddProperty = useFormik({
    initialValues: formAddPropertyInitialValues,
    validate: formAddPropertyValidate,
    validateOnMount: true,
    onSubmit: async () => {
      try {
        const dataRequest: IAddPropertiy[] = [];
        const dataAtributes: IAtribute[] = [];
        stepProperties.forEach((step, idexStep: number) => {
          const validAtributes: IAtribute[] = [];
          atributes?.propiedades.data
            .filter((atribute) => {
              // Solo incluir 'date_marbete' para vehículos en Puerto Rico (PR)
              if (atribute.attributes?.name_intl_eng === 'date_marbete') {
                const isVehicle = isVehicleType(typeProperty);
                const isPR = branch.toLowerCase() === 'pr';
                return isVehicle && isPR;
              }
              return true;
            })
            .forEach((atribute) => {
              const attributeValue =
                atribute.attributes.name === 'Placa'
                  ? formAddProperty.values[
                      `${atributes.name}__${atribute.attributes.name}__${atribute.id}__${step.item}`
                    ]?.toUpperCase()
                  : formAddProperty.values[
                      `${atributes.name}__${atribute.attributes.name}__${atribute.id}__${step.item}`
                    ];

              // Solo agregar el atributo si tiene un valor válido
              if (attributeValue && attributeValue.toString().trim() !== '') {
                validAtributes.push({
                  valor: attributeValue,
                  status: true,
                  propiedad: atribute.id,
                  user_product: formAddProperty.values.userProduct,
                  product_type_id: atributes.id,
                });
              }
            });
          dataRequest[idexStep] = {
            atributos: validAtributes,
          };
        });
        if (atributes?.itemActive === stepProperties.length) {
          await createProductProperties(
            user.uid,
            {
              data: [...dataRequest],
            },
            userImpersonationId,
            user.agentAuthData?.sourceApp ?? 'meraki-frontend',
            user.agentAuthData?.sourceOrigin ?? (window.location.origin + '/')
          );
          navigate('/settings/properties');
        } else {
          handleItemActive((atributes?.itemActive as number) + 1);
        }
      } catch (error: any) {
        if (
          error?.response?.data?.error?.message
            ?.toLowerCase()
            ?.includes('duplicada')
        ) {
          setErrorMessage(
            error?.response?.data?.error?.details?.message ||
              'La propiedad ya existe. Por favor, verifica los datos.'
          );
          setErrorModalOpen(true);
        } else {
          setErrorMessage('Ocurrió un error inesperado. Intenta nuevamente.');
          setErrorModalOpen(true);
        }
      } finally {
        formAddProperty.setSubmitting(false);
      }
    },
  });

  // Cuando el VIN tiene 17 caracteres válidos, quitar el error para que no quede bloqueado
  useEffect(() => {
    if (!atributes?.propiedades?.data) return;
    const vinAttr = atributes.propiedades.data.find(
      (a) =>
        a.attributes.name?.toLowerCase() === 'vin' ||
        a.attributes.name_intl_eng?.toLowerCase() === 'vin'
    );
    if (!vinAttr || !atributes.name || atributes.itemActive == null) return;
    const vinFieldKey = `${atributes.name}__${vinAttr.attributes.name}__${vinAttr.id}__${atributes.itemActive}`;
    const value = formAddProperty.values[vinFieldKey];
    if (typeof value === 'string' && value.length === 17 && isValidVin(value)) {
      formAddProperty.setFieldError(vinFieldKey, undefined);
    }
  }, [
    atributes?.name,
    atributes?.itemActive,
    atributes?.propiedades?.data,
    formAddProperty.values,
    formAddProperty.setFieldError,
  ]);

  const handleSelectOption = (value: number | string, options?: any) => {
    const { info, id } = (options || planesOptions).find(
      (p: any) => p.value === value
    ) as IOptionSelect;

    if (info) {
      const optionMaxCount = +(info as string).split(' ')[0];
      if (optionMaxCount <= 0) {
        setCount((count) => count);
        handlePopUp('selectPlan', id);
        return;
      }
      setMaximumNumberPropertiesAdd(optionMaxCount);
      if (stepProperties.length > 0) {
        handleStepProperties(optionMaxCount);
        setCount(optionMaxCount);
      }
    } else {
      setCount((count) => count);
      setMaximumNumberPropertiesAdd(10);
    }
    formAddProperty.setFieldValue('userProduct', value);
  };

  const validateInput = async (
    event:
      | React.FocusEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLInputElement>,
    typeEvent: 'blur' | 'change',
    formName: string
  ) => {
    let { value } = event.target;
    if (formName.toLowerCase().includes('vin')) {
      value = sanitizeVinInput(value);
    } else if (formName.toLowerCase().includes('placa')) {
      value = value.replace(/[^a-zA-Z0-9]/g, '');
    }
    formAddProperty.setFieldValue(formName, value, true);
    if (formName.toLowerCase().includes('vin')) {
      if (value.length === 17 && isValidVin(value)) {
        formAddProperty.setFieldError(formName, undefined);
      }
    }
    if (!value) {
      formAddProperty.handleBlur(event);
    } else {
      if (
        formName.includes('Año') &&
        value.length >= 4 &&
        Number(value) <= 1990
      ) {
        await formAddProperty.setTouched({ [formName]: true }, false);
        formAddProperty.setErrors({
          [formName]: 'El año debe ser mayor a 1990',
        });
      } else {
        if (typeEvent === 'blur') {
          formAddProperty.handleBlur(event);
        } else {
          formAddProperty.handleChange(event);
        }
      }
    }
  };

  return (
    <>
      <HeaderWithSteps
        navbarTemplate="light"
        steps={step}
        onClick={() => handlePopUp('exitsProcess')}
        notProgress={true}
      />
      <section className="add__property__container">
        {isLoading ? (
          <AddPropertySkeleton></AddPropertySkeleton>
        ) : (
          <div className="add__property__content">
            <img
              className="add__property__icon"
              src={getPropertyInfo(typeProperty).image}
              alt="Tipo de propiedad"
            />
            <Select
              WrapperClassName="grid__span-6"
              id="add-property-select"
              placeholder="Seleccione cobertura"
              value={formAddProperty.values.userProduct}
              name="userProduct"
              onClick={handleSelectOption}
              options={planesOptions}
              isRequired={true}
              errorSelect={formAddProperty.errors.userProduct as string}
              onBlur={formAddProperty.handleBlur}
              isTouched={formAddProperty.touched.userProduct as boolean}
            />
            <p className="add__property__text m--small">
              {getPropertyInfo(typeProperty).message}
            </p>
            <ItemAddProperty
              id="add"
              template="primary"
              maxItems={maximumNumberPropertiesAdd}
              isDisabledButtonPlus={
                stepProperties.length >= maximumNumberPropertiesAdd
              }
              isDisabledButtonLess={stepProperties.length <= 1}
              isDisabled={
                !formAddProperty.values.userProduct &&
                formAddProperty.values.userProduct !== 0
              }
              type={{ ...appConstants }[typeProperty] as TypeProperty}
              onClick={handleStepProperties}
              count={count}
              branch={branch}
            />
            {stepProperties.length > 0 && (
              <>
                <p className="add__property__text">
                  {getPropertyInfo(typeProperty).description}
                </p>
                <form
                  className="add__property__form grid rg-0 grid__col-6"
                  onSubmit={formAddProperty.handleSubmit}
                  noValidate
                >
                  <div className="add__property__form__quantity grid__span-6">
                    {stepProperties.map(
                      (
                        item: {
                          item: number;
                          active: boolean;
                        },
                        index: number
                      ) => (
                        <ButtonIndexProperty
                          key={`${item.item}-${index}`}
                          index={item.item.toString()}
                          isDisabled={item.item !== atributes?.itemActive}
                        ></ButtonIndexProperty>
                      )
                    )}
                  </div>
                  {atributes?.propiedades.data
                    .filter((atribute) => {
                      // Solo mostrar 'date_marbete' para vehículos en Puerto Rico (PR)

                      if (
                        atribute.attributes?.name_intl_eng === 'date_marbete'
                      ) {
                        const isVehicle = isVehicleType(typeProperty);
                        return isVehicle && branch.toLowerCase() === 'pr';
                      }
                      return true;
                    })
                    .sort((a, b) => {
                      if (!isVehicleType(typeProperty)) return 0;
                      return (
                        getVehicleFieldSortKey(
                          a.attributes.name,
                          a.attributes.name_intl_eng
                        ) -
                        getVehicleFieldSortKey(
                          b.attributes.name,
                          b.attributes.name_intl_eng
                        )
                      );
                    })
                    .map(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (atribute, index: number) => {
                        const fieldName = `${atributes.name}__${atribute.attributes.name}__${atribute.id}__${atributes.itemActive}`;
                        const fieldValue =
                          formAddProperty.values[fieldName] || '';
                        const isVehicle = isVehicleType(typeProperty);
                        const dataKey = getVehicleDataKey(typeProperty ?? 1);
                        const isVinField =
                          atribute.attributes.name?.toLowerCase() === 'vin' ||
                          atribute.attributes.name_intl_eng?.toLowerCase() ===
                            'vin';
                        const gridClass =
                          isVehicle && isVinField
                            ? 'grid__span-6'
                            : isVehicle
                            ? 'grid__span-3'
                            : atribute.attributes.large
                            ? 'grid__span-6'
                            : 'grid__span-3';
                        const brands = Object.keys(vehicleData[dataKey] ?? {});
                        const selectedBrand =
                          selectedBrands?.[atributes?.itemActive ?? 0] ?? '';
                        const models =
                          vehicleData[dataKey]?.[selectedBrand] ?? [];

                        if (atribute.attributes.type === 'date') {
                          return (
                            <div
                              key={`date__atribute-${index}`}
                              className={`add-property__field ${gridClass}`}
                            >
                              <CustomPropertyLabel
                                htmlFor={`input__atribute__${fieldName}`}
                                required={
                                  atribute.attributes.required as boolean
                                }
                              >
                                {atribute.attributes.name}
                              </CustomPropertyLabel>
                              <CustomPropertyDate
                                id={`input__atribute__${fieldName}`}
                                value={fieldValue}
                                onChange={(value) => {
                                  formAddProperty.setFieldValue(
                                    fieldName,
                                    value
                                  );
                                  formAddProperty.setFieldTouched(
                                    fieldName,
                                    true
                                  );
                                }}
                                placeholder={atribute.attributes.name}
                                required={
                                  atribute.attributes.required as boolean
                                }
                                minDate={minDate}
                                maxDate={maxDate}
                                hideLabel
                              />
                            </div>
                          );
                        }
                        if (isVehicle && atribute.attributes.name === 'Marca') {
                          return (
                            <div
                              key={`input__atribute-${index}`}
                              className={`add-property__field ${gridClass}`}
                            >
                              <CustomPropertyLabel
                                htmlFor={`input__atribute__${fieldName}`}
                                required={
                                  atribute.attributes.required as boolean
                                }
                              >
                                {atribute.attributes.name}
                              </CustomPropertyLabel>
                              <CustomPropertySelect
                                id={`input__atribute__${fieldName}`}
                                value={fieldValue}
                                onChange={(value) => {
                                  formAddProperty.setFieldValue(
                                    fieldName,
                                    value
                                  );
                                  formAddProperty.setFieldTouched(
                                    fieldName,
                                    true
                                  );
                                  setSelectedBrands((prev) => ({
                                    ...prev,
                                    [atributes?.itemActive ?? 0]: value,
                                  }));
                                  // Al cambiar marca, limpiar modelo (la lista de modelos depende de la marca)
                                  const modeloAttr =
                                    atributes?.propiedades.data.find(
                                      (a) => a.attributes.name === 'Modelo'
                                    );
                                  if (modeloAttr && atributes) {
                                    const modeloFieldKey = `${atributes.name}__${modeloAttr.attributes.name}__${modeloAttr.id}__${atributes.itemActive}`;
                                    formAddProperty.setFieldValue(
                                      modeloFieldKey,
                                      ''
                                    );
                                  }
                                  setTimeout(() => {
                                    formAddProperty.validateForm();
                                  }, 0);
                                }}
                                options={brands}
                                placeholder={`Seleccionar ${atribute.attributes.name.toLowerCase()}`}
                              />
                            </div>
                          );
                        }
                        if (
                          isVehicle &&
                          atribute.attributes.name === 'Modelo'
                        ) {
                          return (
                            <div
                              key={`input__atribute-${index}`}
                              className={`add-property__field ${gridClass}`}
                            >
                              <CustomPropertyLabel
                                htmlFor={`input__atribute__${fieldName}`}
                                required={
                                  atribute.attributes.required as boolean
                                }
                              >
                                {atribute.attributes.name}
                              </CustomPropertyLabel>
                              <CustomPropertySelect
                                id={`input__atribute__${fieldName}`}
                                value={fieldValue}
                                onChange={(value) => {
                                  formAddProperty.setFieldValue(
                                    fieldName,
                                    value
                                  );
                                  formAddProperty.setFieldTouched(
                                    fieldName,
                                    true
                                  );
                                  setTimeout(() => {
                                    formAddProperty.validateForm();
                                  }, 0);
                                }}
                                options={models}
                                placeholder={`Seleccionar ${atribute.attributes.name.toLowerCase()}`}
                              />
                            </div>
                          );
                        }
                        if (
                          isVehicle &&
                          (atribute.attributes.name?.toLowerCase() ===
                            'color' ||
                            atribute.attributes.name_intl_eng?.toLowerCase() ===
                              'color')
                        ) {
                          return (
                            <div
                              key={`input__atribute-${index}`}
                              className={`add-property__field ${gridClass}`}
                            >
                              <CustomPropertyLabel
                                htmlFor={`input__atribute__${fieldName}`}
                                required={
                                  atribute.attributes.required as boolean
                                }
                              >
                                {atribute.attributes.name}
                              </CustomPropertyLabel>
                              <CustomPropertyColorSelect
                                id={`input__atribute__${fieldName}`}
                                value={fieldValue}
                                onChange={(value) => {
                                  formAddProperty.setFieldValue(
                                    fieldName,
                                    value
                                  );
                                  formAddProperty.setFieldTouched(
                                    fieldName,
                                    true
                                  );
                                }}
                                colors={vehiclesColors}
                                placeholder={`Seleccionar ${atribute.attributes.name.toLowerCase()}`}
                              />
                            </div>
                          );
                        }
                        if (atribute.attributes.name === 'Año') {
                          return (
                            <div
                              key={`input__atribute-${index}`}
                              className={`add-property__field ${gridClass}`}
                            >
                              <CustomPropertyLabel
                                htmlFor={`input__atribute__${fieldName}`}
                                required={
                                  atribute.attributes.required as boolean
                                }
                              >
                                {atribute.attributes.name}
                              </CustomPropertyLabel>
                              <Input
                                label={atribute.attributes.name}
                                id={`input__atribute__${fieldName}`}
                                type="number"
                                name={fieldName}
                                placeholder={`Año superior a ${year}`}
                                onChange={(e) =>
                                  validateInput(e, 'change', fieldName)
                                }
                                onBlur={(e) =>
                                  validateInput(e, 'blur', fieldName)
                                }
                                value={fieldValue}
                                isTouched={
                                  formAddProperty.touched[fieldName] as boolean
                                }
                                errorInput={
                                  formAddProperty.errors[fieldName] as string
                                }
                                errorLabel={
                                  formAddProperty.errors[fieldName] as string
                                }
                                isRequired={
                                  atribute.attributes.required as boolean
                                }
                                form={formAddProperty}
                                hideLabel
                              />
                            </div>
                          );
                        }
                        const isVin =
                          atribute.attributes.name?.toLowerCase() === 'vin' ||
                          atribute.attributes.name_intl_eng?.toLowerCase() ===
                            'vin';
                        if (isVin) {
                          return (
                            <div
                              key={`input__atribute-${index}`}
                              className={`add-property__field add-property__field--vin ${gridClass}`}
                            >
                              <Input
                                label={atribute.attributes.name}
                                id={`input__atribute__${fieldName}`}
                                type="alphanumeric"
                                name={fieldName}
                                onChange={(e) =>
                                  validateInput(e, 'change', fieldName)
                                }
                                onBlur={(e) =>
                                  validateInput(e, 'blur', fieldName)
                                }
                                value={fieldValue}
                                isTouched={
                                  formAddProperty.touched[fieldName] as boolean
                                }
                                errorInput={
                                  formAddProperty.errors[fieldName] as string
                                }
                                errorLabel={
                                  formAddProperty.errors[fieldName] as string
                                }
                                isRequired={
                                  atribute.attributes.required as boolean
                                }
                                form={formAddProperty}
                                maxLength={17}
                              />
                            </div>
                          );
                        }
                        return (
                          <div
                            key={`input__atribute-${index}`}
                            className={`add-property__field ${gridClass}`}
                          >
                            <CustomPropertyLabel
                              htmlFor={`input__atribute__${fieldName}`}
                              required={atribute.attributes.required as boolean}
                            >
                              {atribute.attributes.name}
                            </CustomPropertyLabel>
                            <Input
                              id={`input__atribute__${fieldName}`}
                              label={atribute.attributes.name}
                              type={
                                atribute.attributes.name === 'Placa'
                                  ? 'plate'
                                  : (atribute.attributes.type as TypeInput)
                              }
                              name={fieldName}
                              placeholder={
                                atribute.attributes.name === 'Placa'
                                  ? 'ABC123'
                                  : undefined
                              }
                              onChange={(e) =>
                                validateInput(e, 'change', fieldName)
                              }
                              onBlur={(e) =>
                                validateInput(e, 'blur', fieldName)
                              }
                              value={fieldValue}
                              isTouched={
                                formAddProperty.touched[fieldName] as boolean
                              }
                              errorInput={
                                formAddProperty.errors[fieldName] as string
                              }
                              errorLabel={
                                formAddProperty.errors[fieldName] as string
                              }
                              isRequired={
                                atribute.attributes.required as boolean
                              }
                              form={formAddProperty}
                              maxLength={atribute.attributes.length as number}
                              textTransform={
                                atribute.attributes.name === 'Placa'
                              }
                              hideLabel
                            />
                          </div>
                        );
                      }
                    )}
                </form>
              </>
            )}
          </div>
        )}
        <div className="add__property__content">
          <div style={{ marginTop: '51px' }}></div>
          <ContactCard />
          {stepProperties &&
            stepProperties.length > 0 &&
            !stepProperties[0]?.active && (
              <Button
                color="primary"
                size="medium"
                template="primary"
                typeStyle="rounded"
                className="ghost__button mt-30"
                type="submit"
                onClick={backIndex}
              >
                regresar
              </Button>
            )}
          <Button
            styleInLine={{ marginTop: '2rem' }}
            color="primary"
            size="medium"
            template="primary"
            typeStyle="rounded"
            type="submit"
            label={
              atributes?.itemActive === stepProperties.length
                ? 'guardar y salir'
                : 'continuar'
            }
            isDisabled={
              !formAddProperty.isValid ||
              Object.keys(formAddProperty.touched).length === 0 ||
              stepProperties.length === 0
            }
            isLoading={formAddProperty.isSubmitting}
            onClick={formAddProperty.handleSubmit}
          ></Button>
        </div>
      </section>
      {popUp.showModal && (
        <PopupExistProcess
          title={popUp.title}
          message={popUp.message}
          labelButton={popUp.labelButton}
          labelButtonCancel={popUp.labelButtonCancel}
          type="warning"
          closePopUp={() => handlePopUp(undefined)}
          exitProcess={handleClosePopUp}
        />
      )}
      {errorModalOpen && (
        <PopUpInformative
          title={'Error'}
          text={errorMessage}
          type="error"
          closePopUp={() => setErrorModalOpen(false)}
        ></PopUpInformative>
      )}
    </>
  );
};
